<script>
  export let property;
  export let availability;
  export let user;
  export let bookingLink;

  const isAvailable = (prop) => {
    const value = availability.find(v => v.airbetterId === prop.id);

    return value && property.numberOfUnits === 1 ? false : true; 
  };
</script>

<div class="info">
  <div class="info-item">
    <div class="name">
      <h3>
        <a target='_blank'href='https://portals.airbetter.com/properties/propertydetails?id={property.id}'>{property.airbetterName}</a>
      </h3>
      <h5>{property.name}</h5>
      <h4>{#if property.region}{property.region}, {/if}{property.city} {property.typeOfProperty}</h4>
    </div>
    {#if property.numberOfUnits > 1}
      <div class='units'>
        {property.numberOfUnits}
      </div>
    {/if}
    {#if user.accountRole.toLowerCase() !== 'cleaner'}
      {#if isAvailable(property)}
          <a target='_blank' class='reserve-button' href='{bookingLink}'>
            <span class="material-icons">book_online</span>
          </a>
      {/if}
    {/if}
  </div>
</div>

<style>
.info {
  display: flex;
  border-left:1px solid  #ddd;
  border-right:1px solid  #ddd;
}

.info-item {
  height: 43px;
  width: 310px;
  min-width:310px;
  padding:3px 0 3px 10px;
  overflow: hidden;
  position: relative;
  display: flex;
}

.info h3 {
  font-weight: bold;
  color: #666;
  font-size: .8rem;
  line-height: 1.2rem;
  margin: 0; 
  white-space:nowrap;
  overflow:hidden;
}

.info h4 {
  color: #666;
  font-size: 9.5px;
  line-height: 1.3rem;
  font-style: italic;
  margin: 0;
  font-weight:normal;
}

.info h5 {
  font-size:10px;
  margin:0;
  line-height: 10px;
  white-space:nowrap;
  overflow:hidden;
}

.info .name {
  flex:1;
  padding-right:10px;
  overflow: hidden;
}

.info .reserve-button {
  display: block;
  width:48px;
  min-width: 48px;
  height:49px;
  background-color: #EF4064;
  color:white;
  font-size:12px;
  text-align: center;
  line-height: 63px;
  margin-top:-3px;
}

.info .units {
  display: block;
  border:1px solid #ccc;
  border-radius: 50%;
  width:22px;
  height:22px;
  margin:10px 10px 0 0;
  box-shadow: 0px 0px 8px -2px rgba(100,100,100,0.66);
  color:#EF4064;
  font-size:12px;
  text-align: center;
  line-height:22px;
  font-weight: bold;
}
</style>